const API_URL = "";

 export default {
	// API_URL: "https://localhost:8000/api/v1",
	API_URL: "https://portal.activerestoration.com/api/v1",
	APP_URL:"https://www.acts.com"
 };

